import type { UIMatch } from 'react-router';

import { cmsRouteId } from './CmsSplat.horizon-route';
import type { CmsSplatPageLoaderData } from './CmsSplatPageLoaderData';

export function isSearchLandingPageSSRMatch(
  match: UIMatch,
): match is UIMatch<
  Extract<CmsSplatPageLoaderData, { type: 'SEARCH_LANDING_PAGE' }>
> {
  if (match.id !== cmsRouteId) return false;

  const data = match.loaderData as CmsSplatPageLoaderData | undefined;
  if (!data) return false;

  return data.type === 'SEARCH_LANDING_PAGE';
}
